import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/Login/screen'),
    meta: { title: 'Login' }
  },
  {
    path: '/empreendimentosImo',
    name: 'empreendimentosImo',
    component: () => import('@/components/EnviarArquivos/screen'),
    meta: { requiresAuth: true, title: 'Envio de solicitação' }
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/components/VisualizarArquivos/screen'),
    alias: '/home',
    meta: {
      requiresAuth: true,
      permissionDenied: '8276295e-64e0-46ed-b581-31cb53510eef',
      title: 'Visualização de solicitações'
    }
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: () => import('@/components/TimeLine/screen'),
    meta: { requiresAuth: true, title: 'Acompanhamento' }
  },
  {
    path: '/modeloPadrao',
    // name: 'modelPattern',
    component: () => import('@/components/ModeloPadrao/screen'),
    children: [
      {
        path: 'listar',
        component: () => import('@/components/ModeloPadrao/ListModelos'),
        meta: { title: 'Lista de modelos criados' }
      }
    ],
    meta: { requiresAuth: true, title: 'Modelo Padrão' }
  },
  {
    path: '/conta',
    component: () => import('@/components/ContaCliente/screen'),
    children: [
      {
        path: '',
        component: () => import('@/components/ContaCliente/Editar'),
        meta: { title: 'Editar conta' }
      },
      {
        path: 'cadastro',
        component: () => import('@/components/ContaCliente/Cadastro'),
        meta: { title: 'Cadastro nova conta' }
      }
    ],
    meta: { title: 'Editar conta' }
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@/components/Report/screen'),
    meta: { requiresAuth: true, title: 'Relatórios' }
  },
  {
    path: '/usuarios',
    component: () => import('@/components/usuarios/screen'),
    children: [
      {
        path: '',
        component: () => import('@/components/usuarios/lista'),
        name: 'userList',
        meta: { title: 'Lista usuários' }
      },
      {
        path: 'cadastro',
        component: () => import('@/components/usuarios/cadastro'),
        name: 'userAdd',
        meta: { title: 'Cadastro de usuário' }
      },
      {
        path: 'editar/:id',
        component: () => import('@/components/usuarios/editar'),
        name: 'userEdit',
        meta: { title: 'Editar usuário' }
      }
    ],
    meta: {
      requiresAuth: true,
      permissionDenied: '8276295e-64e0-46ed-b581-31cb53510eef',
      title: 'Login'
    }
  },
  {
    path: '/contentManagement',
    name: 'contentManagement',
    component: () => import('@/components/ContentManagement/screen'),
    meta: { requiresAuth: true, title: 'Gestão de conteúdo' }
  },
  {
    path: '*',
    component: () => import('@/components/PageNotFound/screen'),
    meta: { title: 'Page Not Found' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem('token')) {
      if (
        to.matched.some(
          (record) =>
            record.meta.permissionDenied === localStorage.getItem('idPerfil')
        )
      ) {
        next('/timeline')
        return
      } else {
        next()
        return
      }
    }
    next('/login')
  } else {
    next()
  }
})

export default router
